module.exports = __webpack_public_path__ + "media/images/new-ui-images/table-sort-down-c9ed68ddde16a11aee2be977cd56124d.svg";